<div class="filter-by" [class]="styleType">
  <div class="filtration-list">
    <div class="filter-icon">
      <img src="./assets/images/Group.svg" alt="" />
    </div>
    <div class="right">
      <span>Filter By:</span>
      <ng-content></ng-content>
      <div class="down-arrow">
        <img src="./assets/images/icon-chevron-down 2.svg" alt="" />
      </div>
    </div>
  </div>
</div>
